import React from "react";
import UserService from "../../utilities/userService";
import Icon from "../icon/icon";

export interface ISearchButtonProps {
  isMobile?: boolean;
}

function SearchButton(props: ISearchButtonProps) {
  return (
    <button
      className={`input-group-text border-0 d-inline-block ${
        props.isMobile ? "search-button-mobile " : "search-button"
      }`}
      disabled={!UserService.displayUserInfo()}
      type="submit"
    >
      <Icon>search</Icon>
    </button>
  );
}

export default SearchButton;
